import React from 'react';
import { SxProps, Theme } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import { PreloadedAvatar } from './PreloadedAvatar';

interface UserAvatarProps {
  src: string | null | undefined;
  size?: number;
  sx?: SxProps<Theme>;
}

/**
 * User avatar component with AccountCircle as the fallback icon.
 * Wraps PreloadedAvatar to avoid green flash while loading.
 */
export const UserAvatar: React.FC<UserAvatarProps> = ({
  src,
  size = 40,
  sx,
}) => {
  // Scale the icon relative to avatar size (roughly 75% of avatar size)
  const iconSize = Math.round(size * 0.75);

  return (
    <PreloadedAvatar
      src={src}
      size={size}
      fallbackIcon={<AccountCircle sx={{ fontSize: iconSize }} />}
      sx={sx}
    />
  );
};
